import React from 'react';
import { PolicyData } from '../../context/policy';
import {
	PremiumReportData,
	withPremiumReportContext,
} from '../../context/premiumReport';
import {
	BREADCRUMB__INVOICE,
	BREADCRUMB__INVOICES,
} from '../../data/labelsAndMessages';
import { useRouteMatch } from '../../util/useRouteMatch';
import BreadcrumbsContainer, { Breadcrumb } from '../BreadcrumbsContainer';
import {
	PremiumReportRoutes,
	PREMIUM_REPORT_ROUTES,
} from './PremiumReportSidebar';

interface Props {
	policyData: PolicyData;
	premiumReportData: PremiumReportData;
}

const Breadcrumbs = (props: Props) => {
	const { policy } = props.policyData;

	const { premiumReport } = props.premiumReportData;
	const { locator, policyholderLocator } = policy;
	const routeMatch = useRouteMatch(
		Object.keys(PREMIUM_REPORT_ROUTES).map(
			(key) => PREMIUM_REPORT_ROUTES[key as keyof PremiumReportRoutes],
		),
	);
	const params = routeMatch?.params || {};
	const routeName = routeMatch?.pattern?.path || '';

	const breadcrumbs: Breadcrumb[] = [
		{ href: `/policyholder/${policyholderLocator}`, text: 'Policyholder' },
		{ href: `/policy/${locator}/details`, text: `Policy ${locator}` },
		{ href: `/policy/${locator}/premiumReports`, text: 'Premium Reports' },
		{
			href: `/policy/${locator}/premiumReports/${premiumReport.locator}/overview`,
			text: `Premium Report ${premiumReport.locator}`,
		},
	];

	// prepare invoices breadcrumbs
	if (
		[PREMIUM_REPORT_ROUTES.INVOICE, PREMIUM_REPORT_ROUTES.INVOICES].includes(
			routeName,
		)
	) {
		breadcrumbs.push({
			href: PREMIUM_REPORT_ROUTES.INVOICES.replace(
				':policyholderId',
				policyholderLocator,
			)
				.replace(':policyId', locator)
				.replace(':premiumReportId', premiumReport.locator),
			text: BREADCRUMB__INVOICES(),
		});
		if (routeName === PREMIUM_REPORT_ROUTES.INVOICE) {
			breadcrumbs.push({
				href: PREMIUM_REPORT_ROUTES.INVOICE.replace(
					':policyholderId',
					policyholderLocator,
				)
					.replace(':policyId', locator)
					.replace(':premiumReportId', premiumReport.locator)
					.replace(':invoiceId', params.invoiceId),
				text: BREADCRUMB__INVOICE(params.invoiceId),
			});
		}
	}
	return <BreadcrumbsContainer breadcrumbs={breadcrumbs} />;
};

export default withPremiumReportContext<Props>(Breadcrumbs);
